import React from 'react';
import request from 'superagent';
import { connect } from 'react-redux';
import * as actionCreators from './actions';
import { fromJS, List, Map } from 'immutable';

export class ShortlistSideMenu extends React.Component {

  constructor(props) {
    super();
    const data = JSON.parse(props.initialData);
    this.state = { items: [...data], open: false, hasShortlistBeenOpened: false, shareShortlistOpen: false };
  }

  render() {

    return (
      <div className={`shortlist-side-menu ${(this.state.open ? ' --open' : '')}`}>
        <div className={'shortlist-side-menu__close'}
          onClick={() => this.setState({ open: !this.state.open })} />

        <div className={'shortlist-side-menu__share --links'}>
          <div>
            <div className={'page-title__share-container__text'}>Share on:</div>
            <div className={'page-title__share-container__icons'}>
              <a href={'#'}
                aria-label="Facebook"
                data-linkoverride={this.props.shortlistUrl}
                className={'fab fa-facebook-f page-title__share-container__icons__icon facebook-share-button'} />
              <a href={'#'}
                data-linkoverride={this.props.shortlistUrl}
                aria-label="Facebook"
                className={'fab fa-facebook-messenger page-title__share-container__icons__icon --messenger facebook-messenger-share-button'} />
              <a href={'#'}
                aria-label="Twitter"
                data-linkoverride={this.props.shortlistUrl}
                className={'fab fa-twitter page-title__share-container__icons__icon twitter-share-button'} />
              <a href={`mailto:?subject=View my shortlist on Peak Retreats&body=Here is my shortlist on the Peak Retreats website: ${this.props.shortlistUrl}`}
                className={'far fa-envelope page-title__share-container__icons__icon'}
              aria-label="Email"              />
            </div>
          </div>
        </div>

        <div className={'shortlist-side-menu__title'}
          onClick={() => {
            if (!this.state.hasShortlistBeenOpened) {
              this.props.populateShortlistAsync();
            }
            this.setState({ open: !this.state.open, hasShortlistBeenOpened: true });
          }}><span
            className={'shortlist-side-menu__title__inner-text'}>View
            shortlist ({this.props.numberInShortlist})</span>
        </div>

        <div className={'shortlist-side-menu__left-panel'}>
          <div className={'shortlist-side-menu__left-panel__title'}>Your shortlist</div>
          {this.props.shortlistData.count() > 0 ? this.props.shortlistData.map((item, index) => {

            const accoladeList = Array.from(item.get('AccoladeList'));

            return (<li key={index} className={'shortlist-side-menu__item'}>
              <div onClick={() => {
                this.props.removeFromShortlistAsync(item.get('Id'));
              }}
                className={'shortlist-side-menu__item__delete'} title={'Remove from shortlist'} />
              <a href={item.get('Url')} className={'shortlist-side-menu__item__link'}>
                {
                  <div className={'shortlist-side-menu__item__image'}
                    style={{ backgroundImage: `url('${item.get('ImageUrl')}')` }}>
                    {item.get('Premium') === true ? <span className="shortlist-side-menu__item__new-tag --premium">Premium</span>
                      :

                      accoladeList.length > 0 ? <span class="shortlist-side-menu__item__new-tag --white">{accoladeList[0]}</span> : null
                    }
                  </div>
                }
                <div className={'shortlist-side-menu__item__text'}>
                  <div className={'shortlist-side-menu__item__name'}>{item.get('Name')}</div>
                  <div className={'shortlist-side-menu__item__star-rating-container'}>
                    {[...Array(item.get('Rating'))].map((item, index) => {
                      return <span className={'shortlist-side-menu__item__star'}
                        key={`star-rating-star-${index}`} />;
                    })}
                  </div>
                  <div>
                    <div className={'shortlist-side-menu__item__resort-region'}>
                    </div>
                    <div className={'shortlist-side-menu__item__resort-region'}>
                      <span
                        className={'shortlist-side-menu__item__resort-region__title'}>Resort: </span>
                      {item.get('Resort')}
                    </div>
                    <div className={'shortlist-side-menu__item__resort-region'}>
                      <span
                        className={'shortlist-side-menu__item__resort-region__title'}>Board basis: </span>
                      {item.get('BoardBasis')}
                    </div>
                  </div>
                </div>
              </a>

              <div className={'shortlist-side-menu__item__button-container'}>
                {/*<a href={"/quote-request?id={' + item.Id} className='}shortlist-side-menu__item__button --quote">Get a quote</a>*/}
                <a href={item.get('BookingUrl')}
                  className={'shortlist-side-menu__item__button --quote'}>{item.get('ButtonText')}</a>
                {/*<a href={'/about-us/contact-us'} className={'shortlist-side-menu__item__button'}>Contact us</a>*/}
              </div>
            </li>);
          }) : <div className={'shortlist-side-menu__none'}>There is no accommodation in your
            shortlist. You can add accommodation by pressing the 'Add to shortlist' button on the
            accommodation
            page.</div>}
        </div>
      </div>
    );
  }

  componentWillMount() {
    //add event listener to mobile shortlist button
    const shortlistButton = document.getElementsByClassName('header__top-menu__link --shortlist')[0];
    shortlistButton.addEventListener('click', () => {
      this.setState({
        open: !this.state.open
      });
    });
  }

  componentDidUpdate(oldProps, oldState) {

    if (oldState.open !== this.state.open) {
      this.toggleBookingBar();
    }
  }

  toggleBookingBar() {
    let bookingBar = document.getElementsByClassName('booking-form-homepage__form --side-nav');
    if (bookingBar.length > 0) {
      bookingBar = bookingBar[0];
      bookingBar.classList.toggle('--shortlist-open');
      document.body.classList.toggle('--no-padding');
    }
  }
}

export default connect((stateMap, ownProps) => {
  const state = stateMap.get('shortlistSideMenu', Map({}));
  const numberInShortlist = fromJS(state.get('shortlist', List([]))).count();
  const shortlistData = state.getIn(['shortlistData', 'ShortlistItems'], Map({}));
  const shortlistUrl = `/short-list/?ids=${btoa(Object.keys(state.get('shortlist', List([]))).join(','))}`;


  return {
    ...ownProps,
    shortlistUrl,
    numberInShortlist,
    shortlistData
  };
}, actionCreators)
  (ShortlistSideMenu);
